import React, { FunctionComponent } from "react";
import { Helmet } from "react-helmet";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { useSiteMetadata } from "../../../hooks/use-site-metadata";
import { withPrefix } from "gatsby";

export interface SEOProps {
  locale: string;
  isRTL: boolean;
}

export const SEO: FunctionComponent<SEOProps> = ({ locale, isRTL }) => {
  const { imageUrl, siteDomain } = useSiteMetadata();
  const { t } = useTranslation();
  const key = locale === "en-us" ? "" : "home_";
  const title = t(`${key}siteMeta.title`);
  const description = t(`${key}siteMeta.description`);

  return (
    <>
      <Helmet>
        <html lang={locale} dir={isRTL ? "rtl" : ""} />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={withPrefix(`/apple-icon-180x180.png`)}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={withPrefix(`/favicon-32x32.png`)}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={withPrefix(`/favicon-16x16.png`)}
        />
        <link
          rel="icon"
          type="image/x-icon"
          href={withPrefix(`/favicon.ico`)}
        />
      </Helmet>
      <GatsbySeo
        title={title}
        description={description}
        openGraph={{
          url: `${siteDomain}/${locale}`,
          title,
          description,
          images: [{ url: imageUrl }],
          site_name: title,
        }}
      />
    </>
  );
};
